export const availableActivities = [
  {
    module_task_priority: 600,
    data_properties_values: {
      exam_type: 'EXAM_IMPRINT_MEMORY_ASSESSMENT',
      exam_subtype: 'PAIRED_RECOGNITION_ABRIDGED_FLEX',
      exam_code: 'IMAGE_PAIRS_ABRIDGED_V2'
    },
    progress_status: 'not started',
    task: {
      code: 'IMAGE_PAIRS_ABRIDGED_V2',
      title: 'Image Pairs',
      description: 'Paired recognition exam abridged - Flexible Platforms',
      type: 'exam',
      subtype: 'paired_recognition',
      data_properties: {
        exam_type: 'EXAM_IMPRINT_MEMORY_ASSESSMENT',
        exam_subtype: 'PAIRED_RECOGNITION_ABRIDGED_FLEX',
        exam_code: 'IMAGE_PAIRS_ABRIDGED_V2'
      },
      domains_measured: 'Associative Memory',
      duration: '5 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_image_pairs.png'
      }
    }
  },
  {
    module_task_priority: 500,
    data_properties_values: {
      exam_type: 'EXAM_PAIRED_ASSOCIATION',
      exam_subtype: 'PAIRED_ITEM_PRICE_FLEX',
      exam_code: 'ITEM_PRICE_V2'
    },
    progress_status: 'not started',
    task: {
      code: 'ITEM_PRICE_V2',
      title: 'Item Price',
      description: 'Paired Item Price Exam v2 - Flexible Platforms',
      type: 'exam',
      subtype: 'paired_item_price',
      data_properties: {
        exam_type: 'EXAM_PAIRED_ASSOCIATION',
        exam_subtype: 'PAIRED_ITEM_PRICE_FLEX',
        exam_code: 'ITEM_PRICE_V2'
      },
      domains_measured: 'Associative Learning',
      duration: '3 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_item_price.png'
      }
    }
  },
  {
    module_task_priority: 400,
    data_properties_values: {
      exam_type: 'EXAM_PROCESSING_SPEED',
      exam_subtype: 'PAIRED_SYMBOL_DIGITS_ABRIDGED_FLEX',
      exam_code: 'SYMBOL_DIGITS_ABRIDGED_V1'
    },
    progress_status: 'not started',
    task: {
      code: 'SYMBOL_DIGITS_ABRIDGED_V1',
      title: 'Symbol Match',
      description: 'Symbol Match Abridged Exam v1 - Flexible Platforms',
      type: 'exam',
      subtype: 'paired_symbol_digits',
      data_properties: {
        exam_type: 'EXAM_PROCESSING_SPEED',
        exam_subtype: 'PAIRED_SYMBOL_DIGITS_ABRIDGED_FLEX',
        exam_code: 'SYMBOL_DIGITS_ABRIDGED_V1'
      },
      domains_measured: 'Processing Speed',
      duration: '3 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_symbol_match.png'
      }
    }
  },
  {
    module_task_priority: 300,
    data_properties_values: {
      exam_type: 'EXAM_FLANKER',
      exam_subtype: 'ATTENTION_FLEX',
      exam_code: 'FLANKER_V1'
    },
    progress_status: 'not started',
    task: {
      code: 'FLANKER_V1',
      title: 'Arrow Match',
      description: 'Flanker Exam v1 - Flexible Platforms',
      type: 'exam',
      subtype: 'flanker',
      data_properties: {
        exam_type: 'EXAM_FLANKER',
        exam_subtype: 'ATTENTION_FLEX',
        exam_code: 'FLANKER_V1'
      },
      domains_measured: 'Attention',
      duration: '3 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_arrow_match.png'
      }
    }
  },
  {
    module_task_priority: 200,
    data_properties_values: {
      exam_type: 'EXAM_GO_NO_GO',
      exam_subtype: 'INHIBITION_FLEX',
      exam_code: 'GO_NO_GO_V1'
    },
    progress_status: 'not started',
    task: {
      code: 'GO_NO_GO_V1',
      title: 'Light Reaction',
      description: 'Go / No Go Exam v1 - Flexible Platforms',
      type: 'exam',
      subtype: 'go_no_go',
      data_properties: {
        exam_type: 'EXAM_GO_NO_GO',
        exam_subtype: 'INHIBITION_FLEX',
        exam_code: 'GO_NO_GO_V1'
      },
      domains_measured: 'Inhibition',
      duration: '3 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_light_reaction.png'
      }
    }
  },
  {
    module_task_priority: 100,
    data_properties_values: {
      exam_type: 'EXAM_TRAILS',
      exam_subtype: 'TRAILS_B_FLEX',
      exam_code: 'TRAILS_B_V1'
    },
    progress_status: 'not started',
    task: {
      code: 'TRAILS_B_V1',
      title: 'Path Points',
      description: 'Repeatable Trails B Exam v1 - Flexible Platforms',
      type: 'exam',
      subtype: 'trails_b',
      data_properties: {
        exam_type: 'EXAM_TRAILS',
        exam_subtype: 'TRAILS_B_FLEX',
        exam_code: 'TRAILS_B_V1'
      },
      domains_measured: 'Executive Function',
      duration: '3 minutes',
      icon_image: {
        url: 'https://task-icons.cdn.us-neurotrack.io/spot_path_points.png'
      }
    }
  }
]